export const ERROR_UNKNOWN = 'ERROR_UNKNOWN';
export const ERROR_MODEL_NOT_FOUND = 'ERROR_MODEL_NOT_FOUND';

export default (rawError) => {
  let errorArray = Array.isArray(rawError) ? rawError : [rawError];
  errorArray = errorArray.map(e => String(e));

  const parsedErrors = errorArray.map(e => {
    if (e.startsWith('No query results for model')) {
      return ERROR_MODEL_NOT_FOUND;
    }

    return e;
  });

  return Array.isArray(rawError) ? parsedErrors : parsedErrors[0];
};



// WEBPACK FOOTER //
// ./src/util/parse-error.js